<template>
  <div class="rules-wrap">
    <div class="rules-center">
      <img
        v-if="CONTEST_ID === 2"
        class="rules-center-bg"
        src="../assets/images/rules/cos-rule-bg.png"
        alt=""
      />
      <img v-else class="rules-center-bg" src="../assets/images/rules/art-rule-bg.png" alt="" />
      <div class="rules-center-content">
        <img
          class="rules-close"
          src="../assets/images/rules/close.png"
          alt=""
          @click="rulesClose"
        />
        <span v-if="CONTEST_ID === 1 || CONTEST_ID === 0" class="rules-title"
          >Art Contest Rules</span
        >
        <span v-else class="rules-title">Cosplay Contest Rules</span>

        <contest-rules-content :contest-id="CONTEST_ID" class="rules-text" />
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import ContestRulesContent from '@/components/ContestRulesContent'

export default {
  name: 'rules',

  components: { ContestRulesContent },
  data: () => ({}),
  created() {},
  mounted() {},
  watch: {},
  computed: {
    ...mapState({
      CONTEST_ID: state => state.Upload.CONTEST_ID,
    }),
  },
  methods: {
    rulesClose() {
      this.$store.commit('Home/SET_RULES_POPUP_STATE', false)
    },
  },
}
</script>
<style lang="scss" scoped>
.rules-wrap {
  width: 100%;
  height: 100%;
  background-color: #000000c9;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999;

  .rules-title {
    font-family: 'ge';
    font-weight: bold;
    font-size: pxTorem(28px);
    color: white;
    -webkit-text-stroke: pxTorem(3px) #5a3010;
    paint-order: stroke fill;
    display: inline-block;
    text-shadow: 0px 2px 0px #775f3d;
    text-align: center;
    padding-top: 1.7rem;
  }

  .rules-center {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    .rules-center-bg {
      width: pxTorem(1016px);
    }

    .rules-center-content {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;

      .rules-close {
        position: absolute;
        top: pxTorem(32px);
        right: pxTorem(32px);
        cursor: pointer;
      }

      h1 {
        font-size: 24pt;
      }

      h2 {
        font-size: 18pt;
      }

      .rules-text {
        margin: pxTorem(80px) pxTorem(58px) 0 pxTorem(88px);
        margin-top: 1rem;
        padding-right: pxTorem(30px);
        height: 8.5rem;
        overflow-y: scroll;
        padding: 0.5rem 0.8rem 0.5rem 0.8rem;
        padding-top: 0rem;
        padding-left: 0rem;
        padding-right: 0.3rem;
        // border-radius: 1rem;

        &::-webkit-scrollbar {
          width: pxTorem(8px);
          height: pxTorem(4px);
        }

        &::-webkit-scrollbar-thumb {
          border-radius: pxTorem(10px);
          background: #aa8465;
        }

        &::-webkit-scrollbar-track {
          border-radius: pxTorem(10px);
          background: white;
        }

        ::v-deep {
          mark {
            background: transparent;
            color: #2f6a8c !important;
            font-weight: bold;
          }
        }
      }
    }
  }
}
</style>

<style lang="scss"></style>
